import { writable } from 'svelte/store';
import DraftService from '../../services/drafts';
import { step } from '@/store';
import { STEP } from '@/types/common';
const draftService = new DraftService();
const initialDraftState = {
    currentDraft: null,
    savedToCloud: false,
    currentCloudDraftId: null,
    currentStep: null,
    isProject: false,
    metadata: {},
    isSaving: false,
    descriptions: []
};
const { subscribe, update } = writable(initialDraftState);
let draftState;
subscribe(draft => (draftState = draft));
let currentStep;
step.subscribe(step => {
    if (step !== null || step !== STEP.CHOOSE_VIDEO) {
        currentStep = step;
    }
});
let abortController = null;
let currentRequest = null;
let currentUpdate = null;
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    createNewDraft: async (project, metadata = null, name) => {
        if (!project.video)
            throw new Error('Project has no video');
        const draft = await draftService.create({
            project,
            video: project.video.id,
            projectName: name,
            currentStep: currentStep
        });
        update(store => {
            return {
                ...store,
                currentDraft: project,
                savedToCloud: true,
                currentCloudDraftId: draft.id,
                currentStep: draft.currentStep,
                projectName: draft.projectName,
                isProject: draft.isProject,
                isSaving: false,
                metadata
            };
        });
    },
    duplicateDraft: async (draftid) => {
        if (!draftid || isNaN(draftid) || draftid <= 0) {
            console.log('PROJECT HAS NO ID');
            return false;
        }
        const data = await draftService.duplicate(draftid);
        return data.result === true;
    },
    updateDraft: async (project, name, metadata) => {
        if (currentUpdate)
            clearTimeout(currentUpdate);
        if (!project.video)
            return;
        currentUpdate = setTimeout(async () => {
            if (draftState.currentCloudDraftId) {
                update(store => ({ ...store, isSaving: true }));
                await draftService.update(draftState.currentCloudDraftId, {
                    project,
                    projectName: name,
                    currentStep: currentStep,
                    metadata
                });
                update(store => ({
                    ...store,
                    currentDraft: project,
                    projectName: name,
                    currentStep: currentStep,
                    metadata,
                    isSaving: false
                }));
            }
            else {
                console.warn('No draft id.');
            }
            currentUpdate = null;
        }, 500);
    },
    renameDraftClip: async (id, project, name) => {
        if (currentUpdate)
            clearTimeout(currentUpdate);
        return new Promise(resolve => {
            currentUpdate = setTimeout(async () => {
                if (project.video === null || project.template === null)
                    return resolve(false);
                if (!id || !name)
                    return resolve(false);
                if (abortController)
                    abortController.abort();
                abortController = new AbortController();
                try {
                    await draftService.renameProject(id, name);
                    abortController = null;
                }
                catch (error) {
                    console.log('clip update failed', error);
                }
                return resolve(true);
            }, 500);
        });
    },
    updateDraftClip: async (id, project, name) => {
        if (currentUpdate)
            clearTimeout(currentUpdate);
        return new Promise(resolve => {
            currentUpdate = setTimeout(async () => {
                if (project.video === null || project.template === null)
                    return resolve(false);
                if (!id)
                    return resolve(false);
                if (abortController)
                    abortController.abort();
                abortController = new AbortController();
                try {
                    await draftService.update(id, { projectName: name }, { signal: abortController.signal });
                    abortController = null;
                }
                catch (error) {
                    console.log('clip update failed', error);
                }
                return resolve(true);
            }, 500);
        });
    },
    markDraftAsProject: (projectName) => {
        update(store => ({ ...store, isProject: true, projectName }));
    },
    markDraftCompleted: () => { },
    markDraftIncomplete: () => { },
    resetState() {
        update(store => ({
            ...store,
            currentDraft: null,
            savedToCloud: false,
            currentCloudDraftId: null,
            projectName: '',
            currentStep: null,
            isProject: false,
            metadata: {},
            isSaving: false
        }));
    },
    generateSocialDescriptions: async (draftId, regenerate = false) => {
        const socialDescriptions = await draftService.generateSocialDescriptions(draftId, regenerate);
        update(store => ({
            ...store,
            descriptions: socialDescriptions.data
        }));
        return socialDescriptions.data;
    }
};
const draftStore = {
    subscribe,
    ...actions
};
export default draftStore;
function debounceRequest(project, name, metadata) {
    if (currentRequest)
        clearTimeout(currentRequest);
    currentRequest = setTimeout(() => {
        createDraftRequest(project, name, metadata);
        currentRequest = null;
    }, 750);
}
function createDraftRequest(project, name, metadata) {
    if (abortController)
        abortController.abort(); // Cancels the previous request
    abortController = new AbortController();
    return draftService
        .update(draftState.currentCloudDraftId, { project, projectName: name, currentStep, metadata }, { signal: abortController.signal })
        .then(resp => (abortController = null));
}
export let draftName = writable('');
